module.exports = __webpack_public_path__ + "static/assets/03aed75f9a75aef179982d359433dea4.svg";